


import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HarlequinParsedInitData} from "../server/data/HarlequinParsedInitData";
import {Timeline} from "gsap";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";

export class HarlequinBetLineInit implements GameRoundPresentation {

    private _initBetlines:boolean = false;
    private _initComplete:boolean = false;
    private _betLineData:number [][];

    constructor(initBetlines:boolean = false) {
        this._initBetlines = initBetlines;
    }

    prepare(data: HarlequinParsedInitData) {
        //const gameData:HarlequinParsedGameData =  <HarlequinParsedGameData> data;
        //console.log("BL DATA");
        //console.log(data)¨
        //const initData:ParsedInitData = <ParsedInitData> data;
        //debugger;
        if(data!.betLines && data!.betLines.length > 0) {
            //console.log("BET LINE DATA: ");
            //console.log(data!.betLines);
            this._betLineData = data!.betLines;
        }
    }

    getAnimation(): Timeline | null {

        if(this._initBetlines && !this._initComplete) {

            //TODO: call view to init
            this._initComplete = true;

            HarlequinGameModuleConfig.multiplierBetWinView.setUpBetLines(this._betLineData);

            return null;
        }

        return null;
    }
}